import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

import { fetchUrl } from "../../../../functions/fetchUrl";

import Box from '@mui/material/Box';
import Typography from "antd/lib/typography/Typography";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import CircularProgress from '@mui/material/CircularProgress';

const NotificationByCompany = ({ table }) => {

  useState("Loading...");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [networks, setNetworks] = useState([]);
  const [network, setNetwork] = useState("");
  const [carrier, setCarrier] = useState("All");
  const [nloading, setnLoading] = useState(false);

  const [totals, setTotals] = useState({ "rsc-bl": 0, "rfl-bl": 0, "fsc-bl": 0, "ffl-bl": 0, "act-sb": 0, "bld-sb": 0 });

  useEffect(() => {
    setData([])
  }, [table]);

  // console.log(network)
  const columns = [
    {
      field: "numb",
      headerName: "Number",
      width: 130,
    },
    {
      field: "act-sb",
      headerName: "Subscribed_At",
      width: 130,
    },
    {
      field: "bld-sb",
      headerName: "Unsub",
      width: 130,
    },
    {
      field: "fsc-ffl",
      headerName: "First Billing",
      width: 130,
    },
    {
      field: "rsc-bl",
      headerName: "Success Renews",
      width: 150,
    },
    {
      field: "rfl-bl",
      headerName: "Failed Renews",
      width: 130,
    },
  ];

  const parseStatuses = (statusString) => {
    const result = {
      "act-sb": "",
      "bld-sb": "",
      "fsc-ffl": "",
      "rsc-bl": 0,
      "rfl-bl": 0,
      _fsc: false,
      _ffl: false,
      _act: false,
      _bld: false,
    };

    if (!statusString) return result;

    const items = statusString.split(",");

    items.forEach(item => {
      const match = item.trim().match(/^([A-Z-]+)\s*\[(.*?)\]$/);
      if (!match) return;

      const status = match[1];
      const date = match[2];

      switch (status) {
        case "ACT-SB":
          result["act-sb"] = date;
          result._act = true;
          break;

        case "BLD-SB":
          result["bld-sb"] = date;
          result._bld = true;
          break;

        case "FSC-BL":
          result["fsc-ffl"] = "success";
          result._fsc = true;
          break;

        case "FFL-BL":
          result["fsc-ffl"] = "fail";
          result._ffl = true;
          break;

        case "RSC-BL":
          result["rsc-bl"] += 1;
          break;

        case "RFL-BL":
          result["rfl-bl"] += 1;
          break;

        default:
          break;
      }
    });

    return result;
  };


  useEffect(() => {
    const fetchData = async () => {
      setNetwork("");
      setnLoading(true);

      const response = await fetchUrl({
        method: "GET",
        apiName: table + "/getNetworks",
      });

      if (response.success) {
        // Extract networks cleanly
        const nets = response.result.map(n => n.networks);

        // console.log(nets);
        setNetworks(nets);
      }

      setnLoading(false);
    };

    fetchData();
  }, [table]);

  useEffect(() => {
    setData([]);
    setTotals({ "rsc-bl": 0, "rfl-bl": 0, "fsc-bl": 0, "ffl-bl": 0, "act-sb": 0, "bld-sb": 0 });

    if (!network) return;

    let bodySend = { network };
    if (table === "katcha") {
      bodySend = { network, carrier }
    }

    const fetchData = async () => {
      setLoading(true);

      const response = await fetchUrl({
        method: "POST",
        apiName: table + "/getNotifsByNetworks",
        reqBody: bodySend,
      });

      if (response.success) {
        let totalsAcc = {
          "rsc-bl": 0,
          "rfl-bl": 0,
          "fsc-bl": 0,
          "ffl-bl": 0,
          "act-sb": 0,
          "bld-sb": 0,
        };

        const rows = response.result.map((item, index) => {
          const parsed = parseStatuses(item.statuses);

          // accumulate totals
          totalsAcc["rsc-bl"] += parsed["rsc-bl"];
          totalsAcc["rfl-bl"] += parsed["rfl-bl"];

          if (parsed._fsc) totalsAcc["fsc-bl"] += 1;
          if (parsed._ffl) totalsAcc["ffl-bl"] += 1;
          if (parsed._act) totalsAcc["act-sb"] += 1;
          if (parsed._bld) totalsAcc["bld-sb"] += 1;

          return {
            id: index + 1, // DataGrid row id
            numb: item.numb,
            ...parsed,
          };
        });

        setData(rows);
        setTotals(totalsAcc);
      }

      setLoading(false);
    };

    fetchData();
  }, [network, carrier]);

  return (
    <>
      <div style={{ display: "flex", margin: "10px 10px", gap: '10px' }}>
        <div style={{ width: "min-content" }}>
          <FormControl sx={{ m: 1, minWidth: 150 }}>
            <InputLabel id="network-select-label">Network</InputLabel>

            <Select
              labelId="network-select-label"
              id="network-select"
              value={network}
              label="Network"
              onChange={(e) => setNetwork(e.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>

              {networks.map((net, i) => (
                <MenuItem key={`${net}-${i}`} value={net}>
                  {net}
                </MenuItem>
              ))}
            </Select>
            {nloading && (
              <CircularProgress
                size={20}
                sx={{
                  position: "absolute",
                  right: 30,
                  top: "50%",
                  marginTop: "-10px",
                }}
              />
            )}
          </FormControl>

          {table === "katcha" && (
            <FormControl sx={{ m: 1, minWidth: 150 }}>
              <InputLabel id="carrier-select-label">Carrier</InputLabel>

              <Select
                labelId="carrier-select-label"
                id="carrier-select"
                value={carrier}
                label="Carrier"
                onChange={(e) => setCarrier(e.target.value)}
              >
                <MenuItem value="All">
                  <em>All</em>
                </MenuItem>

                <MenuItem value="mobily">mobily</MenuItem>
                <MenuItem value="zain">zain</MenuItem>
              </Select>
            </FormControl>
          )}
        </div>
        <Box sx={{ mt: 0 }}>
          <Typography variant="subtitle1">
            Total Subs (ACT-SB): <b>{totals["act-sb"]}</b>
          </Typography>
          <Typography variant="subtitle1">
            Total 1st Success (FSC-BL): <b>{totals["fsc-bl"]}</b>
          </Typography>
          <Typography variant="subtitle1">
            Total Renew Success (RSC-BL): <b>{totals["rsc-bl"]}</b>
          </Typography>
        </Box>

        <Box sx={{ mt: 0 }}>
          <Typography variant="subtitle1">
            Total UnSubs (BLD-SB): <b>{totals["bld-sb"]}</b>
          </Typography>
          <Typography variant="subtitle1">
            Total 1st Fail (FFL-BL): <b>{totals["ffl-bl"]}</b>
          </Typography>
          <Typography variant="subtitle1">
            Total Renew Fail (RFL-BL): <b>{totals["rfl-bl"]}</b>
          </Typography>
        </Box>
      </div >

      <DataGrid
        className="ml-1"
        rows={data}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[5]}
        style={{ height: "60vh" }}
        getRowId={(data) => data.id}
        loading={loading}
      />
    </>
  );
};

export default NotificationByCompany;
